import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_sales_rep_tenant_pending_submissions_cart: { message: "idle" },
};

export const retrieve_sales_rep_tenant_pending_submissions_cart_Slice = createSlice({
 name: "retrieve_sales_rep_tenant_pending_submissions_cart",
 initialState,
 reducers: {
  success_retrieve_sales_rep_tenant_pending_submissions_cart: (state, action) => {
   state.retrieve_sales_rep_tenant_pending_submissions_cart = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_sales_rep_tenant_pending_submissions_cart: (state, action) => {
   state.retrieve_sales_rep_tenant_pending_submissions_cart = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_sales_rep_tenant_pending_submissions_cart: (state) => {
   state.retrieve_sales_rep_tenant_pending_submissions_cart = { status: app_consts.IDLE };
  },
  loading_retrieve_sales_rep_tenant_pending_submissions_cart: (state) => {
   state.retrieve_sales_rep_tenant_pending_submissions_cart = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_sales_rep_tenant_pending_submissions_cart, fail_retrieve_sales_rep_tenant_pending_submissions_cart, reset_retrieve_sales_rep_tenant_pending_submissions_cart, loading_retrieve_sales_rep_tenant_pending_submissions_cart } = retrieve_sales_rep_tenant_pending_submissions_cart_Slice.actions;

export default retrieve_sales_rep_tenant_pending_submissions_cart_Slice.reducer;